export default __webpack_public_path__ + "static/media/chat.ca0989a8.svg";